// AUTO-GENERATED from docs/curbnturf-rv-checklists.md
// Run `npm run generate:checklist` to regenerate.
// Total sections: 13  Total items: 158

import { IChecklistSection } from './checklist.types';

export const CHECKLIST_SECTIONS: IChecklistSection[] = [
  {
    "id": "01-pre-departure-vehicle-systems",
    "number": 1,
    "title": "Pre-Departure: Vehicle & Systems",
    "items": [
      {
        "id": "01-pre-departure-vehicle-systems--01",
        "text": "Check engine fluids: oil, transmission, brake, coolant, power steering, windshield washer",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--02",
        "text": "Check for fluid leaks under the vehicle",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--03",
        "text": "Check DEF fluid level (diesel rigs)",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--04",
        "text": "Check Aqua Hot fluid level, if equipped",
        "tags": [
          "MH"
        ]
      },
      {
        "id": "01-pre-departure-vehicle-systems--05",
        "text": "Check generator oil and fuel; fill if needed (mind fuel weight)",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--06",
        "text": "If below 50°F, preheat engine 1–2 hours before departure",
        "tags": [
          "MH"
        ]
      },
      {
        "id": "01-pre-departure-vehicle-systems--07",
        "text": "Check tire pressure on RV, tow vehicle, and trailer/toad",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--08",
        "text": "Inspect all tires for wear, cuts, damage, and tread depth (no fabric showing)",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--09",
        "text": "Check spare tire",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--10",
        "text": "Check wheel lug nuts: all present, none loose, torque to spec",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--11",
        "text": "Check battery terminals, water level, and charge condition",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--12",
        "text": "Test all lights and turn signals (RV, tow vehicle, and trailer/toad)",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--13",
        "text": "Test RV/trailer brakes (brake pedal, brake controller, and breakaway switch)",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--14",
        "text": "Inspect windshield for cracks; clean all windows and mirrors",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--15",
        "text": "Adjust mirrors and clean backup cameras",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--16",
        "text": "Fuel up",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--17",
        "text": "Fill fresh water tank to desired level (mind water weight)",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--18",
        "text": "Confirm registration, inspection, and insurance are current",
        "tags": []
      },
      {
        "id": "01-pre-departure-vehicle-systems--19",
        "text": "Confirm spare fluids, tools, fuses, and first-aid kit are on board",
        "tags": []
      }
    ]
  },
  {
    "id": "02-pre-departure-tanks-hookups",
    "number": 2,
    "title": "Pre-Departure: Tanks & Hookups",
    "items": [
      {
        "id": "02-pre-departure-tanks-hookups--01",
        "text": "Empty black tank, then flush it; close black tank valve",
        "tags": []
      },
      {
        "id": "02-pre-departure-tanks-hookups--02",
        "text": "Empty gray tank; close gray tank valve",
        "tags": []
      },
      {
        "id": "02-pre-departure-tanks-hookups--03",
        "text": "Add treatment chemical and a small amount of water to black (and gray) tanks",
        "tags": []
      },
      {
        "id": "02-pre-departure-tanks-hookups--04",
        "text": "Disconnect sewer hose; rinse and stow with accessories",
        "tags": []
      },
      {
        "id": "02-pre-departure-tanks-hookups--05",
        "text": "Disconnect water hose; remove and stow pressure regulator",
        "tags": []
      },
      {
        "id": "02-pre-departure-tanks-hookups--06",
        "text": "Turn off power at pedestal breaker; disconnect and stow power cord",
        "tags": []
      },
      {
        "id": "02-pre-departure-tanks-hookups--07",
        "text": "Disconnect and stow cable TV/satellite and phone lines",
        "tags": []
      },
      {
        "id": "02-pre-departure-tanks-hookups--08",
        "text": "Turn off water pump and water heater (check outside switch)",
        "tags": []
      },
      {
        "id": "02-pre-departure-tanks-hookups--09",
        "text": "Turn off all propane appliances and pilot lights; close propane bottle valves",
        "tags": []
      },
      {
        "id": "02-pre-departure-tanks-hookups--10",
        "text": "Confirm refrigerator is off or switched to 12V/battery power",
        "tags": []
      }
    ]
  },
  {
    "id": "03-pre-departure-interior",
    "number": 3,
    "title": "Pre-Departure: Interior",
    "items": [
      {
        "id": "03-pre-departure-interior--01",
        "text": "Secure refrigerator contents; latch doors",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--02",
        "text": "Clear and secure countertops, sinks, and nightstands",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--03",
        "text": "Put sink covers in place; open sink drain plugs",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--04",
        "text": "Close and latch all cabinets, drawers, closets, and pocket doors",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--05",
        "text": "Latch shower door; put shower items away",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--06",
        "text": "Close and latch stove top cover, oven door, and microwave door",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--07",
        "text": "Secure microwave turntable",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--08",
        "text": "Secure TVs, sliding trays, electronics, and computers",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--09",
        "text": "Secure wall hangings and shelves",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--10",
        "text": "Pad or lay down large items that could shift (chairs, tables)",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--11",
        "text": "Lower all toilet seats",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--12",
        "text": "Close all roof vents and windows; lock windows",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--13",
        "text": "Set window blinds for travel",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--14",
        "text": "Move seats/beds to travel position; confirm front seats are clear of slides",
        "tags": [
          "MH"
        ]
      },
      {
        "id": "03-pre-departure-interior--15",
        "text": "Turn off furnace, A/C, and all lights",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--16",
        "text": "Turn on inverter, if needed for travel",
        "tags": [
          "MH"
        ]
      },
      {
        "id": "03-pre-departure-interior--17",
        "text": "Discard all trash",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--18",
        "text": "Grab maps/GPS, phone and charger, glasses, medications, and pet supplies",
        "tags": []
      },
      {
        "id": "03-pre-departure-interior--19",
        "text": "Confirm travel reservations",
        "tags": []
      }
    ]
  },
  {
    "id": "04-pre-departure-exterior-slides",
    "number": 4,
    "title": "Pre-Departure: Exterior & Slides",
    "items": [
      {
        "id": "04-pre-departure-exterior-slides--01",
        "text": "Lower TV antenna and satellite dish; turn off antenna booster",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--02",
        "text": "Retract and secure all awnings and shades; remove decorations (lights, feeders, flags)",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--03",
        "text": "Collect and stow all outside items: chairs, mats, grills, rugs, clothesline, ladder, doormat",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--04",
        "text": "Secure items carried outside or on the roof (bikes, coolers)",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--05",
        "text": "Check slide tops and toppers for debris and water",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--06",
        "text": "Clear slide paths inside; sweep if needed",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--07",
        "text": "Retract all slides (hold button an extra 5 seconds); install travel locks/braces",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--08",
        "text": "Lock exterior storage bays; confirm cargo trays are latched",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--09",
        "text": "Lock tabs on external range hood vent",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--10",
        "text": "Retract stabilizer jacks and leveling jacks; stow jack pads and blocks",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--11",
        "text": "Visually verify all jacks are up and slides fully retracted",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--12",
        "text": "Remove wheel chocks and stow",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--13",
        "text": "Raise entry steps; stow handrails and decks",
        "tags": []
      },
      {
        "id": "04-pre-departure-exterior-slides--14",
        "text": "Lock entry door and all exterior panels",
        "tags": []
      }
    ]
  },
  {
    "id": "05-hitching-up-tt-fw",
    "number": 5,
    "title": "Hitching Up (TT / FW)",
    "items": [
      {
        "id": "05-hitching-up-tt-fw--01",
        "text": "Grease hitch mechanism where needed",
        "tags": []
      },
      {
        "id": "05-hitching-up-tt-fw--02",
        "text": "Inspect hitch attachment to tow vehicle (nuts, bolts, welds)",
        "tags": []
      },
      {
        "id": "05-hitching-up-tt-fw--03",
        "text": "Remove king pin lock",
        "tags": [
          "FW"
        ]
      },
      {
        "id": "05-hitching-up-tt-fw--04",
        "text": "Lower truck tailgate before backing up",
        "tags": [
          "FW"
        ]
      },
      {
        "id": "05-hitching-up-tt-fw--05",
        "text": "Hitch RV to tow vehicle; verify hitch-pin lock is secure",
        "tags": []
      },
      {
        "id": "05-hitching-up-tt-fw--06",
        "text": "Connect umbilical cord and breakaway switch cable",
        "tags": []
      },
      {
        "id": "05-hitching-up-tt-fw--07",
        "text": "Attach safety chains",
        "tags": [
          "TT"
        ]
      },
      {
        "id": "05-hitching-up-tt-fw--08",
        "text": "Attach sway bars",
        "tags": [
          "TT"
        ]
      },
      {
        "id": "05-hitching-up-tt-fw--09",
        "text": "Raise leveling/tongue jacks; collect blocks",
        "tags": []
      },
      {
        "id": "05-hitching-up-tt-fw--10",
        "text": "Test trailer lights and brakes",
        "tags": []
      },
      {
        "id": "05-hitching-up-tt-fw--11",
        "text": "Double-check hitch and all safety devices",
        "tags": []
      }
    ]
  },
  {
    "id": "06-connecting-a-toad-mh",
    "number": 6,
    "title": "Connecting a Toad (MH)",
    "items": [
      {
        "id": "06-connecting-a-toad-mh--01",
        "text": "Follow the vehicle owner's manual steps for tow mode",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--02",
        "text": "Position vehicle on level ground at proper distance from motorhome",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--03",
        "text": "Connect tow bar and verify it's secure",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--04",
        "text": "Connect safety cables/chains and electrical cable",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--05",
        "text": "Engage supplemental braking system",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--06",
        "text": "Place rock shield/barrier in position",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--07",
        "text": "Put transmission in neutral per manufacturer's instructions",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--08",
        "text": "Release parking brake; key in recommended position",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--09",
        "text": "Test brake lights and turn signals; confirm vehicle lights are off",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--10",
        "text": "Close and lock all doors",
        "tags": []
      },
      {
        "id": "06-connecting-a-toad-mh--11",
        "text": "Inspect toad tires",
        "tags": []
      }
    ]
  },
  {
    "id": "07-final-walk-around",
    "number": 7,
    "title": "Final Walk-Around",
    "items": [
      {
        "id": "07-final-walk-around--01",
        "text": "Walk completely around and under the RV",
        "tags": []
      },
      {
        "id": "07-final-walk-around--02",
        "text": "Confirm all jacks up, slides in, steps up, nothing protruding",
        "tags": []
      },
      {
        "id": "07-final-walk-around--03",
        "text": "Confirm all hoses and cords disconnected and stowed",
        "tags": []
      },
      {
        "id": "07-final-walk-around--04",
        "text": "Confirm hitch and safety devices one last time",
        "tags": []
      },
      {
        "id": "07-final-walk-around--05",
        "text": "Check clearance before pulling out of the site",
        "tags": []
      },
      {
        "id": "07-final-walk-around--06",
        "text": "All family members on board?",
        "tags": []
      },
      {
        "id": "07-final-walk-around--07",
        "text": "All pets on board?",
        "tags": []
      }
    ]
  },
  {
    "id": "08-arrival-check-in-site-assessment",
    "number": 8,
    "title": "Arrival: Check-In & Site Assessment",
    "items": [
      {
        "id": "08-arrival-check-in-site-assessment--01",
        "text": "Park near the entrance without blocking traffic; check in",
        "tags": []
      },
      {
        "id": "08-arrival-check-in-site-assessment--02",
        "text": "Ask about club discounts (Good Sam, Escapees), Wi-Fi details, and gate codes",
        "tags": []
      },
      {
        "id": "08-arrival-check-in-site-assessment--03",
        "text": "Get a park map; plan your route to the site",
        "tags": []
      },
      {
        "id": "08-arrival-check-in-site-assessment--04",
        "text": "Walk the site first: check for level ground, low limbs, and tight turns",
        "tags": []
      },
      {
        "id": "08-arrival-check-in-site-assessment--05",
        "text": "Confirm room for slides, awnings, and cargo doors to open fully",
        "tags": []
      },
      {
        "id": "08-arrival-check-in-site-assessment--06",
        "text": "Confirm hookups match expectations (amperage, water, sewer); test the water faucet",
        "tags": []
      },
      {
        "id": "08-arrival-check-in-site-assessment--07",
        "text": "Plan approach angle, especially for back-in sites",
        "tags": []
      },
      {
        "id": "08-arrival-check-in-site-assessment--08",
        "text": "If no sewer at site, dump tanks at the dump station first; if no water, fill fresh tank",
        "tags": []
      },
      {
        "id": "08-arrival-check-in-site-assessment--09",
        "text": "Determine if trailer/toad must be unhitched before entering the site",
        "tags": []
      }
    ]
  },
  {
    "id": "09-arrival-parking-unhitching-leveling",
    "number": 9,
    "title": "Arrival: Parking, Unhitching & Leveling",
    "items": [
      {
        "id": "09-arrival-parking-unhitching-leveling--01",
        "text": "Use a spotter and two-way radios if available",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--02",
        "text": "Position RV so all hookups are reachable",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--03",
        "text": "Set the parking brake",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--04",
        "text": "Disconnect toad; replace fuse, shift to drive, park it",
        "tags": [
          "Toad"
        ]
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--05",
        "text": "Unload hitch platform cargo (bikes, golf cart)",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--06",
        "text": "Remove sway bars and safety chains",
        "tags": [
          "TT"
        ]
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--07",
        "text": "Disconnect and stow umbilical cord and breakaway cable",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--08",
        "text": "Lower tongue/landing jacks onto blocks; unhitch and drive tow vehicle clear (TT/FW)",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--09",
        "text": "Install king pin lock",
        "tags": [
          "FW"
        ]
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--10",
        "text": "Place pads/blocks under leveling jacks",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--11",
        "text": "Level the RV laterally and lengthwise (add blocks under wheels if needed)",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--12",
        "text": "Chock the wheels",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--13",
        "text": "Deploy stabilizer jacks with light tension only (never lift the RV with them)",
        "tags": []
      },
      {
        "id": "09-arrival-parking-unhitching-leveling--14",
        "text": "Re-check level and adjust",
        "tags": []
      }
    ]
  },
  {
    "id": "10-arrival-hookups",
    "number": 10,
    "title": "Arrival: Hookups",
    "items": [
      {
        "id": "10-arrival-hookups--01",
        "text": "Confirm pedestal breaker is OFF",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--02",
        "text": "Test the outlet with a polarity/outlet tester",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--03",
        "text": "Verify water heater is off before connecting power",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--04",
        "text": "Plug in surge protector, then power cord; turn breaker on",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--05",
        "text": "Check surge protector for errors; verify power inside RV",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--06",
        "text": "Sanitize the spigot; flush the hose briefly to clear debris",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--07",
        "text": "Install water pressure regulator; connect hose",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--08",
        "text": "Set water valve to \"city,\" not \"tank fill\"",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--09",
        "text": "Turn on water and check for leaks",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--10",
        "text": "Verify gray and black valves are closed",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--11",
        "text": "Connect sewer hose securely at both ends",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--12",
        "text": "Leave black valve CLOSED; gray valve per preference",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--13",
        "text": "Open propane valves; check for leaks",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--14",
        "text": "Fill water heater (open a hot faucet until water flows), then turn it on",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--15",
        "text": "Turn off water pump (on city water)",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--16",
        "text": "Confirm refrigerator is running on AC",
        "tags": []
      },
      {
        "id": "10-arrival-hookups--17",
        "text": "Set thermostat (A/C or furnace)",
        "tags": []
      }
    ]
  },
  {
    "id": "11-arrival-setup-comfort",
    "number": 11,
    "title": "Arrival: Setup & Comfort",
    "items": [
      {
        "id": "11-arrival-setup-comfort--01",
        "text": "Deploy steps and handrails",
        "tags": []
      },
      {
        "id": "11-arrival-setup-comfort--02",
        "text": "Unlock slide mechanisms; verify clearance; deploy slides (confirm seals all around)",
        "tags": []
      },
      {
        "id": "11-arrival-setup-comfort--03",
        "text": "Extend awnings if desired",
        "tags": []
      },
      {
        "id": "11-arrival-setup-comfort--04",
        "text": "Raise TV/Wi-Fi antennas and satellite dish; scan channels; set up cell booster",
        "tags": []
      },
      {
        "id": "11-arrival-setup-comfort--05",
        "text": "Connect cable TV if available",
        "tags": []
      },
      {
        "id": "11-arrival-setup-comfort--06",
        "text": "Set out ground cover, chairs, table, and grill",
        "tags": []
      },
      {
        "id": "11-arrival-setup-comfort--07",
        "text": "Remove interior travel fasteners and locks",
        "tags": []
      },
      {
        "id": "11-arrival-setup-comfort--08",
        "text": "Unlock range hood vent tabs",
        "tags": []
      },
      {
        "id": "11-arrival-setup-comfort--09",
        "text": "Return seats to parked position; set the clock",
        "tags": []
      },
      {
        "id": "11-arrival-setup-comfort--10",
        "text": "Turn off inverter",
        "tags": [
          "MH"
        ]
      },
      {
        "id": "11-arrival-setup-comfort--11",
        "text": "Check engine oil once cooled; inspect tires",
        "tags": [
          "MH"
        ]
      },
      {
        "id": "11-arrival-setup-comfort--12",
        "text": "Relax — you've earned it",
        "tags": []
      }
    ]
  },
  {
    "id": "12-dumping-holding-tanks",
    "number": 12,
    "title": "Dumping Holding Tanks",
    "items": [
      {
        "id": "12-dumping-holding-tanks--01",
        "text": "Put on gloves",
        "tags": []
      },
      {
        "id": "12-dumping-holding-tanks--02",
        "text": "Remove RV dump cap; connect sewer hose to RV, then to the sewer inlet",
        "tags": []
      },
      {
        "id": "12-dumping-holding-tanks--03",
        "text": "Open black valve; empty; flush black tank; close valve",
        "tags": []
      },
      {
        "id": "12-dumping-holding-tanks--04",
        "text": "Open gray valve; empty; close valve (gray water rinses the hose)",
        "tags": []
      },
      {
        "id": "12-dumping-holding-tanks--05",
        "text": "Disconnect at RV; elevate and drain hose; rinse hose and sewer end",
        "tags": []
      },
      {
        "id": "12-dumping-holding-tanks--06",
        "text": "Rinse dump apron area",
        "tags": []
      },
      {
        "id": "12-dumping-holding-tanks--07",
        "text": "Replace and secure dump cap; stow hose and accessories",
        "tags": []
      },
      {
        "id": "12-dumping-holding-tanks--08",
        "text": "Add chemical and water to black tank via toilet",
        "tags": []
      }
    ]
  },
  {
    "id": "13-choosing-a-great-site",
    "number": 13,
    "title": "Choosing a Great Site",
    "items": [
      {
        "id": "13-choosing-a-great-site--01",
        "text": "Avoid dumpsters, dump stations, and high-traffic areas",
        "tags": []
      },
      {
        "id": "13-choosing-a-great-site--02",
        "text": "Avoid shared hookups and infringing on footpaths or streams",
        "tags": []
      },
      {
        "id": "13-choosing-a-great-site--03",
        "text": "Confirm room for slides and awnings",
        "tags": []
      },
      {
        "id": "13-choosing-a-great-site--04",
        "text": "Shade in summer, open sky in winter",
        "tags": []
      },
      {
        "id": "13-choosing-a-great-site--05",
        "text": "Consider satellite/cell reception",
        "tags": []
      },
      {
        "id": "13-choosing-a-great-site--06",
        "text": "Prefer level sites",
        "tags": []
      },
      {
        "id": "13-choosing-a-great-site--07",
        "text": "Avoid stagnant water (mosquitoes)",
        "tags": []
      }
    ]
  }
];
